import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "noUpdates"
}

import { Icon } from '../../Atoms';
import { StatusDetailsTabView } from '../../Organisms';
import { InfoCard } from '../../Molecules';
import { RteContentType } from '../../types';
import { useServiceStatusStore } from '../../stores';
import { INFO_CARD_COLOR } from '../../../../constants/info-card-color';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTabView',
  props: {
    heading: {},
    isEmpty: { type: Boolean },
    rteContent: {}
  },
  setup(__props: any) {

const serviceStatusStore = useServiceStatusStore();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StatusDetailsTabView), { "rte-content": _ctx.rteContent }, {
    header: _withCtx(() => [
      _createElementVNode("h3", null, _toDisplayString(_ctx.heading), 1)
    ]),
    emptyStateContainer: _withCtx(() => [
      (_ctx.isEmpty && !_unref(serviceStatusStore).isServiceStatusError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Icon), { "icon-name": "tickBlack" }),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('Service: no update')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    infoCard: _withCtx(() => [
      (_unref(serviceStatusStore).isServiceStatusError)
        ? (_openBlock(), _createBlock(_unref(InfoCard), {
            key: 0,
            "icon-name": "warning",
            text: _ctx.$t('Trouble retrieving service'),
            lg: true,
            "background-color": _unref(INFO_CARD_COLOR).white,
            "border-color": _unref(INFO_CARD_COLOR).red
          }, null, 8, ["text", "background-color", "border-color"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["rte-content"]))
}
}

})